/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
import { l } from '@atproto/lex-schema';
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js';
import * as MaterialDefs from './defs.defs.js';
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js';
const $nsid = 'org.okazu-diary.material.external';
export { $nsid };
/** A descriptor of a pornographic material. */
const main = /*#__PURE__*/ l.record('tid', $nsid, 
/*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
    record: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref((() => RepoStrongRef.main))),
    title: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    author: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref((() => profile))),
    description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    thumb: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref((() => thumb))),
    tags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref((() => MaterialDefs.tag)), { maxLength: 64 })),
    labels: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.typedUnion([
        /*#__PURE__*/ l.typedRef((() => LabelDefs.selfLabels)),
    ], false)),
    genericLabels: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.typedUnion([
        /*#__PURE__*/ l.typedRef((() => LabelDefs.selfLabels)),
    ], false)),
    lang: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'language' })),
    via: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref((() => RepoStrongRef.main))),
}));
export { main };
const $type = $nsid;
export { $type };
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
/** Link to an external profile of a person or an entity. */
const profile = /*#__PURE__*/ l.typedObject($nsid, 'profile', 
/*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    uri: /*#__PURE__*/ l.string({ format: 'uri' }),
    record: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref((() => RepoStrongRef.main))),
    avatar: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref((() => avatar))),
}));
export { profile };
const avatar = /*#__PURE__*/ l.typedObject($nsid, 'avatar', 
/*#__PURE__*/ l.object({
    image: /*#__PURE__*/ l.ref((() => thumb)),
    style: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string()),
}));
export { avatar };
const thumb = /*#__PURE__*/ l.typedObject($nsid, 'thumb', 
/*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
    url: /*#__PURE__*/ l.string({ format: 'uri' }),
}));
export { thumb };
//# sourceMappingURL=external.defs.js.map